var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"station"},[_c('div',{staticClass:"media-screen view360-screen"},[_c('Three60Environment',{attrs:{"panos":_vm.panoData,"heading":"360 Panorama","copy":""}})],1)]),_c('StationNav',{attrs:{"station":_vm.stationData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }